import { endpoints } from 'services/endpoints';
import request from 'services/request';
import { paramsToFormData } from 'utils/utils';

export default {
  getRefCodeList: (params: RefCodeListReqDto): Promise<RefCodeListResDto> =>
    request({
      url: endpoints.refcode.list,
      method: 'get',
      params,
    }),

  postRefCodeInsert: (params: RefCodeAddReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.refcode.add,
      method: 'post',
      data: paramsToFormData(params),
    }),  

  postRefCodeUpdate: (params: RefCodeSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.refcode.update,
      method: 'post',
      data: paramsToFormData(params),
    }),    

  postRefCodeSort: (params: RefCodeSortReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.refcode.sort,
      method: 'post',
      data: paramsToFormData(params),
    }),     
    
  getBizCategoryList: (params: BizCategoryListReqDto): Promise<BizCategoryListResDto> =>
    request({
      url: endpoints.refcode.bizlist,
      method: 'get',
      params,
    }),

  getBizCategoryTree: (): Promise<BizCategoryTreeResDto> =>
    request({
      url: endpoints.refcode.biztree,
      method: 'get',
    }),    
    
  postBizCategoryInsert: (params: BizCategoryAddReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.refcode.bizadd,
      method: 'post',
      data: paramsToFormData(params),
    }),  

  postBizCategoryUpdate: (params: BizCategorySaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.refcode.bizupdate,
      method: 'post',
      data: paramsToFormData(params),
    }),    

  postBizCategorySort: (params: BizCategorySortReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.refcode.bizsort,
      method: 'post',
      data: paramsToFormData(params),
    }),   
    
  getLectureCodeList: (): Promise<LectureCodeListResDto> =>
    request({
      url: endpoints.refcode.lecture.codelist,
      method: 'get',
    }),

  getLectureCategoryList: (): Promise<CommonListResDto> =>
    request({
      url: endpoints.refcode.lecture.cate.list,
      method: 'get',
    }),
  postLectureCategoryInsert: (params: LectureCategorySaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.refcode.lecture.cate.add,
      method: 'post',
      data: paramsToFormData(params),
    }),  

  postLectureCategoryUpdate: (params: LectureCategorySaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.refcode.lecture.cate.update,
      method: 'post',
      data: paramsToFormData(params),
    }), 

  getLectureGroupList: (params: LectureGroupLisReqtDto): Promise<CommonListResDto> =>
    request({
      url: endpoints.refcode.lecture.group.list,
      method: 'get',
      params,
    }),
  postLectureGroupInsert: (params: LectureGroupSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.refcode.lecture.group.add,
      method: 'post',
      data: paramsToFormData(params),
    }),  

  postLectureGroupUpdate: (params: LectureGroupSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.refcode.lecture.group.update,
      method: 'post',
      data: paramsToFormData(params),
    }), 

  postLectureGroupDelete: (params: LectureGroupSaveReqDto): Promise<CommonResDto> =>
    request({
      url: endpoints.refcode.lecture.group.delete,
      method: 'post',
      data: paramsToFormData(params),
    }), 
    getPmList: (params: CodeReqDto): Promise<UserCodeListDto> =>
    request({
      url: endpoints.refcode.pmlist,
      method: 'get',
      params,
    }),    
  getCmList: (params: CodeReqDto): Promise<UserCodeListDto> =>
    request({
      url: endpoints.refcode.cmlist,
      method: 'get',
      params,
    }), 
  getOpList: (params: CodeReqDto): Promise<UserCodeListDto> =>
    request({
      url: endpoints.refcode.oplist,
      method: 'get',
      params,
    }),   
  getMailCodeList: (params: MailTemplateCodeListReqDto): Promise<UserCodeListResDto> =>
    request({
      url: endpoints.refcode.mail.codelist,
      method: 'get',
      params,
    }),  
  getEMailCodeList: (params: MailTemplateCodeListReqDto): Promise<UserCodeListResDto> =>
    request({
      url: endpoints.refcode.mail.codelistN,
      method: 'get',
      params,
    }),     
};
